import { useCallback, useState } from "react"

const useInput = (initialValue = "") => {
  const [value, setValue] = useState(initialValue)

  const handleOnChange = useCallback((value) => {
    return setValue(value)
  }, [])

  return {
    value,
    handleOnChange,
  }
}

export default useInput
